import React from "react";
import {Link} from "react-router-dom";


class Order extends React.Component {
    constructor(props) {
        super(props);

        this.state = {};

    }

    render() {
        return (
            <Link to={"/dashboard/captains/captain/" + this.props.data.id} className={"card text-decoration-none"}>
                <div className="card-body">
                    <div>
                        <strong className="text-primary">Ime: </strong>
                        <span>{this.props.data.name}</span>
                    </div>
                    <div>
                        <strong className="text-primary">Email: </strong>
                        <span>{this.props.data.email}</span>
                    </div>
                </div>
            </Link>
        );
    }
}

Order.propTypes = {};

export default Order;
